import { useEffect, useState } from 'react';
import {
  Container,
  Content,
  StyleEquipamentInfo,
  StyleMaintenanceInfo,
  StyledBoxBorder,
  StyledBoxContent,
  StyledBoxLeft,
  StyledClientInfo,
  StyledEquipmentPhoto,
  StyledLocationLogo,
  StyledLocationLogoContainer,
  StyledPreventiveMaintenance,
  GoToLeankeepButton,
  OpenChamadoButton,
} from '../styled';

import imgPlaceholder from 'assets/images/placeholder_img.jpg';
import SocialLinks from '../components/socials';
import { ReactComponent as ChevronIcon } from 'assets/icons/chevron-right.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus-icon.svg';
import { URLS } from 'constants/urls';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';
const Unidades = ({ code }) => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addresses, setAddresses] = useState({});
  const setCookie = useCookies()[1];
  const history = useHistory();
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const getQueryParam = param => {
          return new URLSearchParams(location.search).get(param);
        };
        const debug = getQueryParam('debug');
        const response = await fetch(
          `${process.env.REACT_APP_LIGHTHOUSE_FILTERS_API}/v1/qrcode/public?QrCode=${code}&IgnoreCounts=true`,
          { signal: controller.signal },
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        //const isDev = process.env.NODE_ENV === 'development';
        if (!isMounted) return;
        if (data.site.empresa === 7015 || data.site.empresa === 7526 || debug) {
          const empresaId = debug ? 4157 : data.site.empresa;
          setCookie(
            'chamadoWoba',
            {
              qrcode: code,
              endereco: data?.site?.endereco,
              empresa: empresaId,
              site: data?.site?.site,
              nome: data?.site?.nome,
            },
            { path: '/', domain: URLS.cookieDomain },
          );
          history.push(`/chamado/${code}`);
          return;
        }
        setCookie(
          'qrcodeFilters',
          {
            type: 'U',
            site: { value: data?.site?.site, label: data?.site?.nome },
          },
          { path: '/', domain: URLS.cookieDomain },
        );
        if (isMounted) setData(data);

        const addressesResponse = await fetch(
          `${process.env.REACT_APP_LIGHTHOUSE_FILTERS_API}/v1/homepageempresa/${data.site.empresa}`,
          { signal: controller.signal },
        );
        const addressesData = await addressesResponse.json();
        if (isMounted) setAddresses(addressesData);
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('Erro:', error);
        if (isMounted) setError(error.toString());
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };
    if (code) {
      fetchData();
    }
    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>Não autorizado</div>;
  }

  const socialLinks = {
    instagram: addresses.instagran || null,
    facebook: addresses.facebook || null,
    linkedin: addresses.linkedin || null,
    site: addresses.url || null,
  };
  const goTo = () => {
    setCookie('openNewChamado', { openNewChamado: false }, { path: '/', domain: URLS.cookieDomain });
    const newWindow = window.open('', '_blank');
    newWindow.location.href = history.createHref({ pathname: '/login' });
  };
  const openNewChamado = () => {
    setCookie('openNewChamado', { openNewChamado: true }, { path: '/', domain: URLS.cookieDomain });
    const newWindow = window.open('', '_blank');
    newWindow.location.href = history.createHref({ pathname: '/login' });
  };
  return (
    <Container>
      <Content>
        <StyledBoxBorder>
          <StyledLocationLogoContainer>
            <StyledLocationLogo
              src={
                data.site?.empresaObj?.logomarcaPath
                  ? `${process.env.REACT_APP_URL_IMAGES}${data.site.empresaObj.logomarcaPath}`
                  : imgPlaceholder
              }
              alt="Logo Cliente"
            />
          </StyledLocationLogoContainer>
          <StyledClientInfo>
            <div>
              <h2>{data.site?.empresaObj?.nome || ''}</h2>
              <a href={'/clientes/' + addresses?.subdominio}>
                Saiba mais <ChevronIcon />
              </a>
            </div>
            <h4>Endereço</h4>
            <p>
              {addresses.endereco ? addresses.endereco + ',' : ' '}{' '}
              {addresses.numero ? addresses.numero?.replace(/\D/g, '') + '-' : ''}{' '}
              {addresses.cidadeObj?.nome ? addresses.cidadeObj.nome + ',' : ''}{' '}
              {addresses.cidadeObj?.estadoNome ? addresses.cidadeObj?.estadoNome : ''}
              {addresses.cep ? ' - ' + addresses.cep : ''}
            </p>
            {addresses.telefone ? (
              <>
                <h4>Contato</h4>
                <p>{addresses.telefone?.replace(/_$/, '')}</p>
              </>
            ) : null}
            <SocialLinks links={socialLinks} />
          </StyledClientInfo>
          <StyleEquipamentInfo>
            <h2>Unidade</h2>
            <div>
              <StyledEquipmentPhoto
                src={
                  data.site?.logomarcaPath
                    ? `${process.env.REACT_APP_URL_IMAGES}${data.site.logomarcaPath}`
                    : imgPlaceholder
                }
                alt="Foto da Unidade"
              />
              <span>
                <span>
                  <h3>Nome da unidade</h3>
                  <p>{data.site?.nome || '-'}</p>
                </span>
                <span>
                  <h3>Endereço</h3>
                  <p>{data.site?.endereco || '-'}</p>
                </span>
              </span>
            </div>
          </StyleEquipamentInfo>
          <StyleMaintenanceInfo>
            <h2>Manutenção</h2>
            <h3>Possui ocorrências em aberto?</h3>
            <p>{data.qtdOcorrenciasPendentes ? 'Sim' : 'Não'}</p>
            <h3>
              Tem Atividades Preventivas realizadas nos <br /> últimos 30 dias?
            </h3>
            <p>{data.qtdAtividadesUltimoMes ? 'Sim' : 'Não'}</p>
            <div>
              <OpenChamadoButton onClick={openNewChamado}>
                {' '}
                <PlusIcon /> ABRIR UM CHAMADO
              </OpenChamadoButton>
              <GoToLeankeepButton onClick={goTo}>
                HISTÓRICO<span></span>
              </GoToLeankeepButton>
            </div>
          </StyleMaintenanceInfo>
        </StyledBoxBorder>
        <StyledBoxLeft>
          <StyledBoxContent>
            <div>
              <h2>Especificações da Unidade</h2>
            </div>
            <div>
              <span>
                <span>
                  <h3>Quantidade de Áreas</h3>
                  <p>{data.site?.quantidadeAreas || '-'}</p>
                </span>

                <span>
                  <h3>Quantidade de Equipamentos</h3>
                  <p>{data.site?.quantidadeEquipamentos || '-'}</p>
                </span>
              </span>
            </div>
          </StyledBoxContent>

          <StyledPreventiveMaintenance>
            <div>
              <span className="firstSpan">
                <h2>Maximize a eficiência em manutenção preventiva</h2>
                <p>Descubra como a Leankeep pode revolucionar sua gestão de manutenção preventiva.</p>
                <button>Saiba mais</button>
              </span>
              <span className="secondSpan"></span>
            </div>
          </StyledPreventiveMaintenance>
        </StyledBoxLeft>
      </Content>
    </Container>
  );
};

export default Unidades;
